import { render, staticRenderFns } from "./EditOPCParamModal.vue?vue&type=template&id=5478eb42"
import script from "./EditOPCParamModal.vue?vue&type=script&lang=js"
export * from "./EditOPCParamModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports